import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import {
  StdCard} from 'components'
import { ProcurementBody } from '../../../styled'
import {ProcessRow} from './ProcessRow'

const Comments = (props) => {
  const {
    valueForm,
    isEdit = true
  } = props
  return (
    <ProcurementBody>
      <StdCard title='Comments' accessoriesHeader={props.accessoriesHeader||null}>
        {
          valueForm&&valueForm.comments&&valueForm.comments.map((item,i)=>{
            if(isEdit){
              let files = valueForm.attachments.filter(x=>x.commentId===item.id)
              return (<ProcessRow data={item} files={files}/>)
            }else{
              let commentAttachments = valueForm&&valueForm.attachments?valueForm.attachments.find(x=>x.attachTypeName=='comment').item:[]
              let files = commentAttachments.filter(x=>x.commentId===item.id)
              return (<ProcessRow data={item} files={files}/>)
            }
          })
        }
      </StdCard>
    </ProcurementBody>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formEditPR')(state),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Comments)